'use client'

import type { MouseEventHandler } from 'react'
import { cx } from './utils/cx'
import { useAccent, type AccentVar } from './AccentContext'

interface LogoProps {
  size?: 'sm'
  href?: string
  text?: string
  accent?: AccentVar
  onClick?: MouseEventHandler<HTMLAnchorElement>
  className?: string
}

export function Logo({ size, href = '#', text = 'SnapTransfer', accent, onClick, className }: LogoProps) {
  const { v } = useAccent()
  const a = accent || v
  return (
    <a href={href} onClick={onClick} className={cx('st-wordmark', size, className)}>
      <span className="mark" style={{ background: `var(${a})` }}>
        <svg
          width="26"
          height="26"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#0a0a0a"
          strokeWidth="3"
          strokeLinecap="square">
          <path d="M4 14 L12 6 L20 14" />
          <path d="M12 6 L12 20" />
        </svg>
      </span>
      {text}
    </a>
  )
}
